// import { Tabs } from 'basic-ui-lib';
import styled from 'styled-components';
import MediaContent from '../MediaContent';
import { FormInstance } from 'antd';
import { FormValues } from '../PlaylistForm';
// import LinkContent from '../LinkContent';

interface PlaylistMediaProps {
  form?: FormInstance<FormValues>;
}
const PlaylistMedia = ({ form }: PlaylistMediaProps) => {
  // const items = [
  //   {
  //     label: 'Media',
  //     key: 'media',
  //     children: <MediaContent form={form} />,
  //   },
  //   {
  //     label: 'Links',
  //     key: 'links',
  //     children: <LinkContent form={form} />,
  //   },
  // ];


  return (
    <Container>
      {/* <Tabs items={items} /> */}
      <MediaContent form={form} />
    </Container>
  );
};

export default PlaylistMedia;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  justify-content: space-between;
`;
